import React, { FC } from "react";
import layoutStyles from "./childrenModeGreetingLayout.module.scss";
import styles from "./ChildrenModeSeaGreeting.module.scss";

type ChildrenModeSeaGreetingProps = {
  title: string;
  subTitle: string;
};

export const ChildrenModeSeaGreeting: FC<ChildrenModeSeaGreetingProps> = ({
  title,
  subTitle,
}) => (
  <div className={layoutStyles.root}>
    <p className={styles.text}>{title}</p>
    <p className={styles.text}>{subTitle}</p>
  </div>
);
